<template>
  <div>
    <v-card>
    <v-data-table
      :headers="this.$store.getters.tradeResponseIsEdit ?itemsTableFieldsMoreDetail :itemsTableFields "
      :items="items"
      tableClasses="item-table border"
      responsive
      hide-default-footer
      fixed-header
      disable-pagination
      max-height="200"
      item-key="title"
    >     
    <template v-slot:[`item.indexImage`]="{ item }">
            <v-img
            v-if="item.file &&item.file.thumbnailFileUrl"
            :src="item.file.thumbnailFileUrl"
            width="50px"
            height="50px"
            />
          </template>
         <template v-slot:[`item.description`]="{ item }">
            {{
              item.description?  
              item.description.length >30
               ? item.description.slice(0, 30) + "..."
               : item.description
               :'وارد نشده'
            }}
          </template>
          
          <template v-slot:[`item.operations`]="{ item }">
             <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                @click="$emit('removeAttachedItem', item)"
                >
                  <v-icon color="error" dark v-bind="attrs" v-on="on">
                    mdi-trash-can
                  </v-icon>
                </v-btn>
              </template>
              <span>حذف</span>
            </v-tooltip>
          </template>
             
    </v-data-table>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'TradeRequestInventoryItemsList',
  props: {
  items:{
    type:Array
  },

  },
  data() {
    return {
       itemsTableFieldsMoreDetail: [
        {
          value: 'indexImage',
          text: 'نشانگر فایل آپلود شده',
          sortable: true,
        },
        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },
      //  {
      //     value: 'status',
      //     text: 'وضعیت',
      //     sortable: true,
      //   },
        {
          value: 'documentTypeTitle',
          text: 'نوع مدرک',
          sortable: true,
        },
        {
          value: 'operations',
          text: 'عملیات',
          sortable: true,
        },
      ],
      itemsTableFields: [
        {
          value: 'type',
          text: 'نوع مدرک',
          sortable: true,
        },
        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },
        {
          value: 'fileSize',
          text: 'سایز',
          sortable: true,
        },
        {
          value: 'fileType',
          text: 'فرمت فایل',
          sortable: true,
        },
        {
          value: 'operations',
          text: 'عملیات',
          sortable: true,
        },
      ],

    };
  },
  watch:{
    selected(){
       this.$emit('selectedItem', this.selected)
    }
  }
};
</script>

<style></style>
